import { SeverityNumber, } from '@opentelemetry/api-logs';
import { LogLevel } from '../../types';
export const logLevelMap = {
    [LogLevel.ERROR]: SeverityNumber.ERROR,
    [LogLevel.WARN]: SeverityNumber.WARN,
    [LogLevel.INFO]: SeverityNumber.INFO,
    [LogLevel.DEBUG]: SeverityNumber.DEBUG,
    [LogLevel.TRACE]: SeverityNumber.TRACE,
    [LogLevel.FATAL]: SeverityNumber.FATAL,
    [LogLevel.UNSPECIFIED]: SeverityNumber.UNSPECIFIED,
};
export const logMessageWithSeverity = (logger, message, severity, recordArgs = {}) => {
    return logger.emit({
        severityNumber: logLevelMap[severity],
        severityText: severity,
        body: message,
        ...recordArgs,
    });
};
//# sourceMappingURL=utils.js.map